import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { LuUsers, LuUserPlus } from "react-icons/lu";
import { TbUserCog } from "react-icons/tb";
import { FaRegTrashAlt } from "react-icons/fa";

const OSPLayout = () => {
  const location = useLocation();

  return (
    <>
      <div className="mb-20 px-4">
        {/* Header Section */}
        <div className="border-b border-gray-300 py-7">
          <h1 className="text-3xl  font-semibold text-[#667085]">
            OSP
          </h1>
        </div>

        {/* Navigation Links */}
        <div className="flex gap-10  mb-8 pt-10 border-b">
          <NavLink
            to="all-active-osp"
            className={({ isActive }) =>
              isActive ||
              location.pathname === "/admind-ashboard/buyer" ||
              location.pathname.startsWith(
                "/admin-dashboard/osp/all-active-osp"
              )
                ? "flex items-center gap-2 text-blood text-lg font-medium border-b-[3px] border-blood"
                : "flex items-center gap-2 text-[#667085] text-lg font-medium"
            }
          >
            <span>
              <LuUsers />
            </span>
            All Active OSP
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex items-center gap-2 text-blood text-lg font-medium border-b-[3px] border-blood"
                : "flex items-center gap-2 text-[#667085] text-lg font-medium"
            }
            to="add-osp"
          >
            <span>
              <LuUserPlus />
            </span>
            Add OSP
          </NavLink>

          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex items-center gap-2 text-blood text-lg font-medium border-b-[3px] border-blood"
                : "flex items-center gap-2 text-[#667085] text-lg font-medium"
            }
            to="osp-settings"
          >
            <span>
              <TbUserCog />
            </span>
            OSP Settings
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex items-center gap-2 text-blood text-lg font-medium border-b-[3px] border-blood"
                : "flex items-center gap-2 text-[#667085] text-lg font-medium"
            }
            to="osp-trash"
          >
            <span>
              <FaRegTrashAlt />
            </span>
           Trash
          </NavLink>
        </div>
        <div>
         <Outlet />
        </div>
      </div>
    </>
  );
};

export default OSPLayout;